__turbopack_context__.v({
  "dialSegment": "styles-module-scss-module__NjXH1W__dialSegment",
  "dialSegment__modLookingGood": "styles-module-scss-module__NjXH1W__dialSegment__modLookingGood",
  "dialSegment__modNeedsAttention": "styles-module-scss-module__NjXH1W__dialSegment__modNeedsAttention",
  "dialSegment__modUnfilled": "styles-module-scss-module__NjXH1W__dialSegment__modUnfilled",
  "dialSegment__modWorthLook": "styles-module-scss-module__NjXH1W__dialSegment__modWorthLook",
});
